module.exports = __webpack_public_path__ + "static/media/clipboard-list-outline.e532095b.svg";